import {Component, OnInit} from "@angular/core";
import {LoadingWheelService} from "../../root/loading/loading-wheel.service";
import {Router} from "@angular/router";
import {SessionService} from "../../core/session.service";
import {EvaButton} from "../../shared/eva-button/eva-button";
import {WindowRef} from "../../core/window-ref";

@Component({
    selector: 'internal-error',
    templateUrl: './internal-error.component.html',
})
export class InternalErrorComponent implements OnInit {

    constructor(private loading:LoadingWheelService, private route: Router,
                private sessionService: SessionService, private windowRef: WindowRef) { }

    ngOnInit(): void {
        this.loading.hide();
    }

    backToHome():void {
        this.route.navigateByUrl('/company/' + this.getCompanyId() + '/home');
    }

    getCompanyId(){
        if(!!this.sessionService.getUserSession()){
            return this.sessionService.getUserSession().companyOid;
        }
    }

    isButtonVisible(): boolean {
        return this.sessionService.isLoggedIn();
    }

    getButtonModel(): EvaButton {
        if(this.sessionService.isLoggedIn()) {
            return new EvaButton('companyRequest.landing.iconTooltip.HOME', '-primary', '-md');
        } else {
            return new EvaButton('internalError.GO_TO_LOGIN', '-primary', '-md');
        }
    }

    handleButtonClick(): void {
        if(this.sessionService.isLoggedIn()) {
            this.backToHome();
        } else {
            this.goToLogin();
        }
    }

    private goToLogin() {
        this.windowRef.goHref("../login-atp3");
    }

}


// WEBPACK FOOTER //
// ./public/upgrade/feature/internal-error/internal-error.component.ts